import { defineMessages } from 'react-intl-next';

export const messages: {
	smart_answer_card_generating: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smart_answer_card_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smart_answer_card_dynamic_layout_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smart_answer_card_rovo_generating: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smart_answer_card_rovo_is_thinking: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sources_rail_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	smart_answer_card_generating: {
		id: 'search_ai.smart_answer_card_generating',
		defaultMessage: 'Generating',
		description: 'Text for smart answer card loading state',
	},
	smart_answer_card_title: {
		id: 'search_ai.smart_answer_card.title',
		defaultMessage: 'Answer',
		description: 'Title for the smart answer card',
	},
	smart_answer_card_dynamic_layout_title: {
		id: 'search_ai.smart_answer_card_dynamic_layout_title',
		defaultMessage: 'Overview',
		description: 'Title for the smart answer card dynamic layout',
	},
	sources_rail_title: {
		id: 'search_ai.sources_rail_title',
		defaultMessage: 'Sources',
		description: 'Title for the sources right rail section',
	},
	smart_answer_card_rovo_generating: {
		id: 'search_ai.smart_answer_card_rovo_generating',
		defaultMessage: 'Rovo is {queryReasoning}',
		description: 'Text for the smart answer card "Rovo is" loading state',
	},
	smart_answer_card_rovo_is_thinking: {
		id: 'search_ai.smart_answer_card_rovo_is_thinking',
		defaultMessage: 'Rovo is thinking',
		description: 'Text for the smart answer card "Rovo is thinking" loading state',
	},
});
